import { createAction } from 'redux-actions';
import {
  REQUEST_ACCOUNT_LIST_SUCCESS,
  REQUEST_ACCOUNT_LIST_FAILURE,
  CREATE_ACCOUNT_SUCCESS,
  CREATE_ACCOUNT_FAILURE,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
  ACTIVATE_TOOLTIP,
  NEW_ACCOUNT_ADDED
} from '../constants/actionTypes';
import * as Account from '../api/accountManager';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbar';
import { logout } from './authentication';

const requestAccountListSuccess = createAction(REQUEST_ACCOUNT_LIST_SUCCESS);
const requestAccountListFailure = createAction(REQUEST_ACCOUNT_LIST_FAILURE);

/* eslint-disable import/prefer-default-export */
export function requestAccountList() {
  return dispatch => Account.requestAccountList()
    .then(({ data }) => {
      return dispatch(requestAccountListSuccess(data))})
    .catch((error) => {
      if(error?.response?.data!=undefined){
      dispatch(requestAccountListFailure(error?.response?.data?.errors?.error))
      }
      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
        dispatch(logout());
      }
    });
}

export function requestAccountListSecondary(data){

  
  return dispatch => dispatch(requestAccountListSuccess(data));
}


const createAccountSuccess = createAction(CREATE_ACCOUNT_SUCCESS);
const createAccountFailure = createAction(CREATE_ACCOUNT_FAILURE);
const activeTooltip = createAction(ACTIVATE_TOOLTIP);
const newAccountAdded = createAction(NEW_ACCOUNT_ADDED);

export function createAccount(params) {
  return dispatch => Account.createAccount(params)
    .then(({ data }) => {
      dispatch(showSuccessSnackbar('Account added successfully'));
      requestAccountList();
      dispatch(activeTooltip())
      dispatch(newAccountAdded(false))
      return dispatch(createAccountSuccess(data));
    })
    .catch((error) => {
      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
      }else{
      dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));}
      return dispatch(createAccountFailure(error));
    });
}

const deleteAccountSuccess = createAction(DELETE_ACCOUNT_SUCCESS);
const deleteAccountFailure = createAction(DELETE_ACCOUNT_FAILURE);

// export function deleteAccount(id) {
//   return dispatch => Account.deleteAccount(id)
//     .then(({ data }) => {
//       dispatch(showSuccessSnackbar('Account deleted successfully'));
//       return dispatch(deleteAccountSuccess({ data, id }));
//     })
//     .catch((error) => {
//       if(error?.response?.status === 401){
//         dispatch(showErrorSnackbar('Session is Expired!!!'));
//       }else{
//       dispatch(showErrorSnackbar('Account delete failed'));}
//       return dispatch(deleteAccountFailure(error));
//     });
// }

export function deleteAccount(id) {
  return dispatch => Account.deleteAccount(id)
    .then(( response) => {
      dispatch(showSuccessSnackbar('Account deleted successfully'));
      return dispatch(deleteAccountSuccess({ response, id }));
    })
    .catch((error) => {
      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
      }else{
      dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));}
      return dispatch(deleteAccountFailure(error));
    });
}

export function deleteBrand(id) {
  return dispatch => Account.deleteBrand(id)
    .then(({ data }) => {
      dispatch(showSuccessSnackbar('Brand deleted successfully'));
      // return dispatch(deleteAccountSuccess({ data, id }));
    })
    .catch((error) => {
      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
      }else{
      dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));}
      return dispatch(deleteAccountFailure(error));
    });
}
